import { Text } from 'domains/reporter/RichTextEditor/core';
import type { RenderLeafProps } from '../../../core';

import { ALLOWABLE_SOURCES_FOR_STYLING, getSourceTextColor } from '../utils';

const TextSourceStyling = ({
  attributes,
  children,
  leaf,
}: RenderLeafProps<Text>): React.ReactElement => {
  if (leaf?.source != null && ALLOWABLE_SOURCES_FOR_STYLING.has(leaf.source)) {
    children = <span style={{ color: getSourceTextColor(String(leaf.source)) }}>{children}</span>;
  }

  return <span {...attributes}>{children}</span>;
};

TextSourceStyling.displayName = 'TextSourceStyling';

export const TextSourceStylingEditable = TextSourceStyling;
export const TextSourceStylingRenderer = TextSourceStyling;
